import React from 'react'
import styles from './Pagination.module.scss'

const Pagination = ({
	currentPage,
	totalPages,
	pageGroupSize,
	currentPageGroupStart,
	onPageChange,
	onPrevGroup,
	onNextGroup,
}) => {
	if (totalPages <= 1) {
		return null
	}

	const endPage = Math.min(currentPageGroupStart + pageGroupSize - 1, totalPages)
	const pageNumbers = []
	for (let i = currentPageGroupStart; i <= endPage; i++) {
		pageNumbers.push(i)
	}

	return (
		<div className={styles.pagination}>
			{currentPageGroupStart > 1 && (
				<button onClick={onPrevGroup} className={styles.navButton}>
					<svg
						width="10"
						height="10"
						viewBox="0 0 10 10"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<g transform="rotate(180 5 5)">
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M5.74686 4.69064C5.91771 4.8615 5.91771 5.1385 5.74686 5.30936L1.37186 9.68436C1.20101 9.85521 0.923995 9.85521 0.753141 9.68436C0.582286 9.5135 0.582286 9.2365 0.753141 9.06564L4.81878 5L0.753141 0.934359C0.582287 0.763505 0.582287 0.486495 0.753141 0.315641C0.923996 0.144786 1.20101 0.144786 1.37186 0.315641L5.74686 4.69064Z"
								fill="#A0A0A0"
							/>
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M9.24686 4.69064C9.41771 4.8615 9.41771 5.1385 9.24686 5.30936L4.87186 9.68436C4.70101 9.85521 4.424 9.85521 4.25314 9.68436C4.08229 9.5135 4.08229 9.2365 4.25314 9.06564L8.31878 5L4.25314 0.934359C4.08229 0.763505 4.08229 0.486495 4.25314 0.315641C4.424 0.144787 4.70101 0.144787 4.87186 0.315641L9.24686 4.69064Z"
								fill="#A0A0A0"
							/>
						</g>
					</svg>
				</button>
			)}
			{pageNumbers.map((number) => (
				<button
					key={number}
					onClick={() => onPageChange(number)}
					className={currentPage === number ? styles.active : ''}>
					{number}
				</button>
			))}
			{endPage < totalPages && (
				<button onClick={onNextGroup} className={styles.navButton}>
					<svg
						width="10"
						height="10"
						viewBox="0 0 10 10"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M5.74686 4.69064C5.91771 4.8615 5.91771 5.1385 5.74686 5.30936L1.37186 9.68436C1.20101 9.85521 0.923995 9.85521 0.753141 9.68436C0.582286 9.5135 0.582286 9.2365 0.753141 9.06564L4.81878 5L0.753141 0.934359C0.582287 0.763505 0.582287 0.486495 0.753141 0.315641C0.923996 0.144786 1.20101 0.144786 1.37186 0.315641L5.74686 4.69064Z"
							fill="#A0A0A0"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M9.24686 4.69064C9.41771 4.8615 9.41771 5.1385 9.24686 5.30936L4.87186 9.68436C4.70101 9.85521 4.424 9.85521 4.25314 9.68436C4.08229 9.5135 4.08229 9.2365 4.25314 9.06564L8.31878 5L4.25314 0.934359C4.08229 0.763505 4.08229 0.486495 4.25314 0.315641C4.424 0.144787 4.70101 0.144787 4.87186 0.315641L9.24686 4.69064Z"
							fill="#A0A0A0"
						/>
					</svg>
				</button>
			)}
		</div>
	)
}

export default Pagination
